const FOLLOW_CONTEXT = {
    FOLLOWING: 'following',
    FOLLOWERS: 'followers',
};

export default FOLLOW_CONTEXT;
